import { routes, userRoles } from "../../../constants";
import {
  baseRouteMaker,
  baseRouteMakerForSuperAdmin,
} from "../../../constants/routeConsts";

export const navigateToScreen = (navigate, notification, userSession) => {
  switch (notification) {
    case "CHAT_MESSAGE":
      // Navigate to chat screen
      if (userSession?.userRole === userRoles.SERVICE_PROVIDER_ADMIN) {
        navigate(baseRouteMaker(routes.USER_CHAT));
      } else {
        navigate(baseRouteMakerForSuperAdmin(routes.TICKET_MANAGEMENT));
      }
      break;

    case "INCOMING_VIDEO_CALL":
      // Navigate to incoming video call screen
      navigate(baseRouteMaker(routes.CHAT));
      break;

    case "NEW_ORGANIZATION_SIGNUP":
      // Navigate to new organization signup screen
      navigate(baseRouteMakerForSuperAdmin(routes.SERVICE_PROVIDER_AUTH));
      break;

    case "NEW_DOCTOR_SIGNUP":
      // Navigate to new doctor signup screen
      navigate(baseRouteMakerForSuperAdmin(routes.LOGIN_AUTH));
      break;

    case "FINE_PAID":
      // Navigate to fine paid screen
      navigate(baseRouteMakerForSuperAdmin(routes.FINE_TANSACTION_HISTORY));
      break;

    case "ORDER_RECEIVED":
      // Navigate to order received screen
      navigate(baseRouteMaker(routes.REQUEST));
      break;

    case "ORDER_ASSIGNED":
      // Navigate to order assigned screen
      navigate(baseRouteMaker(routes.APPOINTMENTS_INFO));
      break;

    case "ORDER_APPOINTMENT_SCHEDULED_REMINDER":
      // Navigate to order appointment scheduled reminder screen
      navigate(baseRouteMaker(routes.APPOINTMENTS_INFO));
      break;

    case "ORDER_REVIEW_ADDED":
      // Navigate to order review added screen
      navigate(baseRouteMaker(routes.SERVICE_PROVIDER_REVIEW_INFO));
      break;

    case "ORDER_CANCELLED":
      // Navigate to order cancelled screen
      navigate(baseRouteMaker(routes.APPOINTMENTS_INFO));
      break;

    case "DOCTOR_NO_SHOW":
      // Navigate to doctor no-show screen
      navigate(baseRouteMaker(routes.APPOINTMENTS_INFO));
      break;

    case "ORDER_APPOINTMENT_SCHEDULED":
      // Navigate to order appointment scheduled screen
      navigate(baseRouteMaker(routes.REQUEST));
      break;

    case "ORDER_APPROVED":
      // Navigate to order approved screen
      navigate(baseRouteMaker(routes.APPOINTMENTS_INFO));
      break;

    case "ORDER_REJECTED":
      // Navigate to order rejected screen
      navigate(baseRouteMaker(routes.APPOINTMENTS_INFO));
      break;

    case "CHAT_POST_REQUEST_RECEIVED":
      // Navigate to chat post request received screen
      navigate(baseRouteMaker(routes.CHAT_REQUEST));
      break;

    case "CHAT_POST_REQUEST_ACCEPTED":
      // Navigate to chat post request accepted screen
      navigate(baseRouteMaker(routes.USER_CHAT));
      break;

    case "ORDER_COMPLETED":
      // Navigate to order completed screen
      navigate(baseRouteMaker(routes.APPOINTMENTS_INFO));
      break;

    case "ORDER_SERVICE_COMPLETED":
      // Navigate to order service completed screen
      navigate(baseRouteMaker(routes.APPOINTMENTS_INFO));
      break;

    case "WALLET_POINTS_GIFTED":
      // Navigate to wallet points gifted screen
      navigate(baseRouteMaker(routes.WALLET_TRANSACTION));
      break;

    case "ORDER_REFUNDED":
      // Navigate to order refunded screen
      if(userSession?.userRole === userRoles.SERVICE_PROVIDER_ADMIN) {
        navigate(baseRouteMaker(routes.APPOINTMENTS_INFO));
      }
      else {
        navigate(baseRouteMakerForSuperAdmin(routes.SALES_PAGE_APPOINTMENTS))
      }
      break;

    case "CHAT":
      // Navigate to chat screen
      navigate(baseRouteMaker(routes.USER_CHAT));
      break;

    case "VIDEO_CALL":
      // Navigate to video call screen
      navigate(baseRouteMaker(routes.USER_CHAT));
      break;

    case "CHAT_POST":
      // Navigate to chat post screen
      navigate(baseRouteMaker(routes.CHAT_REQUEST));
      break;

    case "WALLET":
      // Navigate to wallet screen
      navigate(baseRouteMaker(routes.WALLET_INFO));
      break;

    case "ORDER":
      // Navigate to order screen
      navigate(baseRouteMaker(routes.APPOINTMENTS_INFO));
      break;

    case "noNotificaiton":
      // Navigate to the default screen when there is no new notification
      navigate("/");
      break;

    case "ORGANIZATION_REGISTERED":
      // Navigate to organization registered screen
      navigate(baseRouteMaker(routes.SERVICE_PROVIDER_AUTH));
      break;

    case "ACCOUNT_RENEWAL_SUCCESSFULL":
      // Navigate to account renewal successful screen
      navigate(baseRouteMaker(routes.STAFF));
      break;

    case "NEW_CHAT_MESSAGE":
      // Navigate to new chat message screen
      if (userSession?.userRole === userRoles.SERVICE_PROVIDER_ADMIN) {
        navigate(baseRouteMaker(routes.USER_CHAT));
      } else {
        navigate(baseRouteMakerForSuperAdmin(routes.TICKET_MANAGEMENT));
      }
      
      break;

    case "OFFER_TOP_LISTING_EXPIRED":
      // Navigate to offer top listing expired screen
      navigate(baseRouteMaker(routes.OFFER));
      break;

    case "ORGANIZATION_TOP_LISTING_EXPIRED":
      // Navigate to organization top listing expired screen
      navigate(
        baseRouteMaker(
          routes.ADDONS_AND_SPONSORSHIPS_ORGANIZATION_SPONSORSHIP_HISTORY
        )
      );
      break;

    case "PACKAGE_TOP_LISTING_EXPIRED":
      // Navigate to package top listing expired screen
      navigate(baseRouteMaker(routes.PACKAGES));
      break;

    case "ORGANIZATION_PAYROLL_SUCCESSFULL":
      // Navigate to organization payroll successful screen
      navigate(baseRouteMakerForSuperAdmin(routes.PAYROLL));
      break;

    case "SUBSCRIPTION_PLAN_PURCHASED":
      // Navigate to subscription plan purchased screen

      if (userSession.userRole === userRoles.SUPER_ADMIN) {
        navigate(baseRouteMakerForSuperAdmin(routes.ACTIVE_SUBSCRIPTION));
      } else {
        navigate(
          baseRouteMaker(routes.SERVICE_PROVIDER_SUBSCRIPTIONS_PLAN_HISTORY)
        );
      }

      break;
      
    case "TOP_LISTING_SUBSCRIPTION_PLAN_PURCHASED":
      // Navigate to organization sponsorship screen

      if (userSession.userRole === userRoles.SUPER_ADMIN) {
        navigate(baseRouteMakerForSuperAdmin(routes.ORGANIZATION_SPONSORSHIP));
      } else {
        navigate(baseRouteMaker(routes.ADDONS_AND_SPONSORSHIPS_ORGANIZATION_SPONSORSHIP_HISTORY));
      }

      break;

    case "PUSH_NOTIFICATION_PURCHASED":
      // Navigate to push notification purchased screen
      if (userSession.userRole === userRoles.SUPER_ADMIN) {
        navigate(baseRouteMakerForSuperAdmin(routes.ADDONS));
      } else {
        navigate(
          baseRouteMaker(
            routes.ADDONS_AND_SPONSORSHIPS_PUSH_NOTIFICATION_HISTORY
          )
        );
      }

      break;

    case "SUBSCRIPTION_EXPIRED":
      // Navigate to subscription expired screen
      if (userSession.userRole === userRoles.SUPER_ADMIN) {
        navigate(baseRouteMakerForSuperAdmin(routes.INACTIVE_SUBSCRIPTION));
      } else {
        navigate(
          baseRouteMaker(routes.SERVICE_PROVIDER_SUBSCRIPTIONS_PLAN_HISTORY)
        );
      }
      break;

    case "NEW_CATEGORY_ADDED":
      // Navigate to new category added screen
      navigate(baseRouteMaker(routes.SERVICES));
      break;

    case "GIFTCARD_PURCHASED":
      // Navigate to gift card purchased screen
      if (userSession.userRole === userRoles.SUPER_ADMIN) {
        navigate(baseRouteMakerForSuperAdmin(routes.DISCOUNT_CODES));
      } else {
        navigate(baseRouteMaker(routes.GIFT_CARD_TRANSACTIONS));
      }
      break;

    case "NEW_SUPPORT_TICKET":
      // Navigate to new support ticket screen
      navigate(baseRouteMakerForSuperAdmin(routes.TICKET_MANAGEMENT));
      break;

    case "GIFTCARD_EXPIRED":
      // Navigate to gift card expired screen
      if (userSession.userRole === userRoles.SUPER_ADMIN) {
        navigate(baseRouteMakerForSuperAdmin(routes.DISCOUNT_CODES));
      } else {
        navigate(baseRouteMaker(routes.GIFT_CARD_TRANSACTIONS));
      }
      break;

    case "COUPON_CODE_EXPIRED":
      if (userSession.userRole === userRoles.SUPER_ADMIN) {
        navigate(baseRouteMakerForSuperAdmin(routes.COUPON_CODES));
      }
      break;

    case "SPONSORSHIP_PURCHASED":
      // Navigate to sponsorship purchased screen

      if (userSession.userRole === userRoles.SUPER_ADMIN) {
        navigate(baseRouteMakerForSuperAdmin(routes.ORGANIZATION_SPONSORSHIP));
      } else {
        navigate(
          baseRouteMaker(
            routes.OFFERS_AND_PACKAGES
          )
        );
      }
      break;

    case "ORDER_REFUND_PROCESSED":
      // Navigate to order refund processed screen
      if (userSession.userRole === userRoles.SUPER_ADMIN) {
        navigate(baseRouteMakerForSuperAdmin(routes.SALES_PAGE_APPOINTMENTS));
      } else {
        navigate(baseRouteMaker(routes.APPOINTMENT));
      }
      break;

    case "GIFTCARD_PURCHASE_SUCCESSFULL":
      // Navigate to gift card purchase successful screen
      navigate(baseRouteMaker(routes.GIFT_CARD_TRANSACTIONS));
      break;

    case "SUPPORT_TICKET_CLOSED":
      // Navigate to support ticket closed screen
      navigate(baseRouteMakerForSuperAdmin(routes.TICKET_MANAGEMENT));
      break;

    case "PAYOUT_SUCCESSFULL":
      // Navigate to payout successful screen
      navigate(baseRouteMakerForSuperAdmin(routes.PAYROLL));
      break;

    default:
      // Default navigation if the notification type is not matched
      navigate("/");
      break;
  }
};
